import 'promise-polyfill/src/polyfill';
import "core-js/stable";
import "regenerator-runtime/runtime";
import InitCabinet from "./initialize/InitCabinet";
import {setTinymceBaseUrl} from "~/cabinet/vue/interface/tinymce/useInputWithVariables";


InitCabinet();
setTinymceBaseUrl(`/cabinet/assets/scripts/tinymce`);